import { render, staticRenderFns } from "./SchoolApplicationView.vue?vue&type=template&id=f81155ac&scoped=true"
import script from "./SchoolApplicationView.vue?vue&type=script&lang=js"
export * from "./SchoolApplicationView.vue?vue&type=script&lang=js"
import style0 from "./SchoolApplicationView.vue?vue&type=style&index=0&id=f81155ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81155ac",
  null
  
)

export default component.exports